<template>
	<sf-modal-layout class="qms-pop1" :title="getMessage_('QWCC002012')" :show="show" :closeModal="close">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 h-100 card_bg">
				<div class="sf-search-layout__body__container">
					<sf-search-layout>
						<el-row :gutter="20">
							<!-- 검사기간 -->
							<el-col :span="6">
								<div class="sf-input-group-wrapper">
									<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001224') }}</span>
									<el-date-picker
										v-model="searchDateRange"
										type="daterange"
										align="right"
										:start-placeholder="getMessage_('QWCC000920')"
										:end-placeholder="getMessage_('QWCC000954')"
										range-separator="~"
										value-format="yyyyMMdd"
									/>
								</div>
							</el-col>
							<el-col :span="4">
								<!-- 품번 -->
								<search-input
									:label="getMessage_('QWCC000956') + ' / ' + getMessage_('QWCC000957')"
									paramKey="partNm"
									@commInput="onChangeData"
									:clearable="false"
									:propData="partNm"
								>
									<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
								</search-input>
							</el-col>
							<!-- 종합판정 -->
							<el-col :span="4">
								<select-combo
									:label="getMessage_('QWCC000008')"
									paramKey="ovrlJgmtCd"
									:options="ovrlJgmtCdList"
									:propData="ovrlJgmtCd"
									@commChange="onChangeData"
								></select-combo>
							</el-col>
							
						</el-row>
						<template slot="button">
							<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
								{{ getButtonMsg_(scrId, 'CR') }}
							</sf-button>
						</template>
					</sf-search-layout>
				</div>
			</sf-card>
		</div>
		<div class="sf-col sf-col-10">
			<sf-card class="p-0 border-0 bg-transparent h-100">
				<sf-data-table
					ref="popupTable"
					:pageUnit="partCkuInfo.pageUnit"
					:totalSize="partCkuInfo.totalSize"
					paging
					index
					:columns="columns"
					:rows="partCkuList"
					height="60vh"
					fit="fit"
					:stripe="false"
					:excel="isButton_(scrId, 'EX')"
					@changedPage="changedPage"
				>
				</sf-data-table>
			</sf-card>
		</div>
		<!-- 팝업추가 영역 -->
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</sf-modal-layout>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/fcku/FwdCkuTest/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput, SelectCombo, PartMngPopup },
	data() {
		return {
			show: false,
			partNo: '',
			partNm: '',
			ovrlJgmtCd: 'SG', //SG결품
			searchDateRange: ['', '']
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async open() {
			this.show = true;
			this.refresh();
			await this.searchList();
		},
		close() {
			this.show = false;
		},
		refresh() {
			this.partNo = '';
			this.partNm = '';
			this.ovrlJgmtCd = 'SG';
			this.searchDateRange = [this.$moment().subtract(6, 'days').format('YYYYMMDD'), this.$moment().format('YYYYMMDD')];
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				if (!this.searchDateRange || this.searchDateRange.length < 2) {
					this.searchDateRange = ['', ''];
				}
				await this.getPartCkuList_({
					strDt: this.searchDateRange[0],
					endDt: this.searchDateRange[1],
					partNo: this.partNo || this.partNm,
					ovrlJgmtCd: this.ovrlJgmtCd
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onChangeData({ key, value }) {
			this[key] = value;
			if (key === 'partNm') {
				this.partNo = '';
			}
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.partNm);
		},
		sendData(row) {
			this.partNo = row.partNo;
			this.partNm = (() => {
				if (this.langCd === 'en_US') {
					return row.enPartNm;
				} else if (this.langCd === 'ko_KR') {
					return row.koPartNm;
				}
				return row.chPartNm;
			})();
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPmcPagingInfo_({ key: 'currentPage', value: currentPageVal, info: 'partCkuInfo' });
			this.setPmcPagingInfo_({ key: 'pageUnit', value: pageUnitVal, info: 'partCkuInfo' });
			await this.searchList();
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC000008'), //종합판정
					prop: 'ovrlJgmtCd',
					minWidth: '70px',
					form: {
						type: 'select',
						options: this.ovrlJgmtCdList,
						placeholder: ' ',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC000005'), //검사번호
					prop: 'ckuNo',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC000007'), //검사분류
					prop: 'ckuClNm',
					minWidth: '70px'
				},
				{
					label: this.getMessage_('QWCC000987'), //검사구분
					prop: 'ckuScnNm',
					minWidth: '90px'
				},
				{
					label: this.getMessage_('QWCC001390'), //검사일
					prop: 'ckuDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC002010'), // 검사시작일시
					prop: 'ckuStrtDt',
					minWidth: '150px'
				},

				{
					label: this.getMessage_('QWCC002011'), //검사종료일시
					prop: 'ckuEndDt',
					minWidth: '150px'
				},
				{
					label: this.getMessage_('QWCC000033'), //부품분류
					prop: 'partClNm',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC000958'), //협력사
					prop: 'cofNm',
					minWidth: '90px'
				}
			];
		}
	}
};
</script>

<style lang="scss" scoped>
.sf-button.sf-line-default {
	min-width: fit-content;
}
</style>
